export default __webpack_public_path__ + "static/app-templates-ad06a41032cf1408378a607e363f625b.png";